import { createContext, useContext } from 'react';

import { CompanyName, type EnvVariables } from '~/company/interface';

export interface GlobalContext {
  redirectUrl?: string;
  isMobile: boolean;
  isTablet: boolean;
  isSSR?: boolean;
  serverNow?: number;
  serverLang?: string;
  serverWarehouse?: string;
  company: CompanyName;
  variables?: EnvVariables;
  isOriginalLogic: boolean;
  /**
   * Delivery-service switch `isCourierDeliveryEnabled`, resolved during the SSR
   * preload. Transport only: it travels in the serialized state so the client
   * company singleton can pick it up before hydration. Read it from
   * `company.hasDeliveryTypeSwitcher`, not from this context.
   */
  isCourierDeliveryEnabled?: boolean;
}

export const GlobalContext = createContext<GlobalContext>({
  isMobile: false,
  isTablet: false,
  isSSR: false,
  company: CompanyName.CityDrinks,
  isOriginalLogic: true,
});

export const useGlobal = (): GlobalContext => {
  return useContext(GlobalContext);
};
